import { useMutation } from '@tanstack/react-query';
import getUserSession from '@utils/getSession';
import {
  DOCS_ORIGIN,
  IDocsAccessRequest,
  validDocsHandoff
} from '_clean-code/api/docs/docsHandoff';

export function useDocsAccess() {
  return useMutation({
    retry: false,
    mutationFn: async (request: IDocsAccessRequest): Promise<string> => {
      if (!DOCS_ORIGIN) throw new Error('DOCS_ACCESS_UNAVAILABLE');
      const { token } = await getUserSession();
      const response = await fetch(`${DOCS_ORIGIN}/auth/ticket`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          state: request.state,
          returnTo: request.returnTo
        }),
        referrerPolicy: 'no-referrer'
      });
      if (!response.ok) throw new Error('DOCS_ACCESS_FAILED');
      const data: { url?: unknown } = await response.json();
      if (!validDocsHandoff(data.url)) throw new Error('DOCS_ACCESS_FAILED');
      return data.url;
    }
  });
}
